import React from 'react'
import { CardHeader, Typography } from '@material-ui/core';
// eslint-disable-next-line
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  cardHeader: {
    padding: 0,
    paddingBottom: '5px',
  },
  cardTitle: {
    fontWeight: 700,
    marginBottom: 0,
  },
}))

export default props => {
  const classes = useStyles()
  const { title } = props

  const isValidElement = React.isValidElement(title)
  let titleNode = ''
  if (isValidElement) {
    titleNode = React.cloneElement(title, { className: classes.cardTitle })
  } else {
    titleNode = (
      <Typography variant="h6" component="h6" gutterBottom className={classes.cardTitle}>
        {title}
      </Typography>
    )
  }

  return <CardHeader className={classes.cardHeader} {...props} title={titleNode} />
}
